import React from "react";
import { Form, FormGroup, Input, Label, ModalBody } from "reactstrap";
//i18n
import { withTranslation } from "react-i18next"

const RequestModalBody = ({ t, setName, setNote }) => {
  return (
    <ModalBody>
      <Form>
        <FormGroup>
          <Label for="attachmentName">
            {t('Name')}<span class="attachment-mandatory-field">*</span>
          </Label>
          <Input
            type="text"
            name="attachmentName"
            id="attachmentName"
            onChange={(e) => {
              setName(e?.target?.value);
            }}
            placeholder={t('Enter file name')}
            maxLength="200"
          />
        </FormGroup>
        <FormGroup>
          <Label for="attachmentNote">
            {t('Reason')}<span class="attachment-mandatory-field">*</span>
          </Label>
          <Input
            type="text"
            name="attachmentNote"
            id="attachmentNote"
            onChange={(e) => {
              setNote(e?.target?.value);
            }}
            placeholder={t('Enter the reason')}
            maxLength="200"
          />
        </FormGroup>
      </Form>
    </ModalBody>
  );
};

export default withTranslation()(RequestModalBody);
